const style = {
  personasControls: {},
  personasControls__row: {
    'display': 'flex',
    'justifyContent': 'space-between',
    'alignItems': 'center',
    'padding': '12px 20px 4px',
    'gap': '16px',

    '@media only screen and (max-width: 640px)': {
      padding: '10px 20px',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '8px',
    },
  },
  personasControls__row_buttons: {
    'display': 'flex',
    'justifyContent': 'end',
    'alignItems': 'center',
    'padding': '12px 20px 4px',

    '@media only screen and (max-width: 640px)': {
      padding: '10px 20px',
    },
  },
  personasControls__nameSearchInputForm: {
    paddingTop: '1px',
    paddingBottom: 0,
    width: '100%',
  },
};

export default style;
